import React from "react";
import cn from "classnames";
import { useField } from "formik";

import InputError from "components/InputsField/InputError";
import Label from "components/InputsField/Label";

import styles from "./styles.module.scss";

interface FormikTextareaFieldProps {
  label?: string;
  labelClasses?: string;
  errorMode?: any;
  required?: boolean;
  maxLength?: number;
  showCharCounter?: boolean;
  [key: string]: any;
}

export const FormikTextareaField: React.FC<FormikTextareaFieldProps> = ({ label, labelClasses, errorMode, required, maxLength, showCharCounter, ...props }) => {
    const [field, meta] = useField(props);
    const currentLength = field.value?.length || 0;

    return (
      <div className={cn(labelClasses, styles.wrapper)}>
        {label && <Label label={label} required={required} name={field.name} />}
        <div className={styles.textareaContainer}>
          <textarea
            id={field.name}
            className={cn(styles.input, {
              [styles['input--warn']]: meta.touched && meta.error,
            })}
            maxLength={maxLength}
            {...field}
            {...props}
          />
          {showCharCounter && maxLength && (
            <span className={styles.charCounter}>
              {currentLength}/{maxLength}
            </span>
          )}
        </div>
        {meta.touched && meta.error ? <InputError message={meta.error} mode={errorMode || 'top-right'} /> : null}
      </div>
    );
};
